export var DEFAULT_BOARD_DIMENSIONS = { x: 3840, y: 2160 };
export var DEFAULT_Z_INDEX = -1000;
